import { fetch } from '../fetchWrapper/fetch';
import { CHANNELS_API_URL } from '../../constants';

export const deleteChannel = async (channelId: string): Promise<boolean> => {
  try {
    const res = await fetch(`${CHANNELS_API_URL}/${channelId}`, { method: 'DELETE' });
    return res.status === 204;
  } catch (e) {
    throw new Error(e.message);
  }
};
